export const initTheme = {
    wireframe: false,
}